export default __webpack_public_path__ + "static/media/Mercenary's Gloves of Crouching Calm.6f3cebed.jpg";